import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-4 md:p-0 w-full max-w-lg mx-auto" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "flex flex-col space-y-2" }
const _hoisted_5 = { class: "flex flex-col space-y-2" }
const _hoisted_6 = { class: "space-y-1 leading-none" }
const _hoisted_7 = { class: "space-y-1 leading-none" }
const _hoisted_8 = { class: "space-y-1 leading-none" }

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { toast } from '@/components/ui/toast'
import * as z from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
import { Loader2 } from 'lucide-vue-next'
import { useAxios } from '@/composables/useAxios'
import { onMounted, ref } from 'vue'
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import Toaster from '@/components/ui/toast/Toaster.vue'
import router from '@/router'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Course } from '@/interfaces/Course'

type FormSchemaType = z.infer<typeof formSchema>


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCommunityView',
  setup(__props) {

const isCreatingCommunity = ref(false)
const axios = useAxios()
const courses = ref<Course[]>()

const requiredMessage = {
  required_error: "Este campo é obrigatório",
}

const formSchema = z.object({
  name: z.string(requiredMessage).min(3, "O nome deve ter pelo menos 3 caracteres"),
  allowReactions: z.boolean().default(true),
  allowPosts: z.boolean().default(true),
  allowChat: z.boolean().default(true),
  courseId: z.string(requiredMessage)
});

function handleSubmit(meta: any, values: FormSchemaType, validate: () => void, resetForm: () => void) {
  validate();
  if (meta.valid) {
    createCommunity(values, resetForm);
  }
}

function createCommunity(payload: FormSchemaType, resetForm: () => void) {
  isCreatingCommunity.value = true
  const { courseId, ...data } = payload

  axios.post(`/courses/${courseId}/communities`, data)
    .then(() => {
      toast({
        title: 'Comunidade criada com sucesso!',
        description: 'Sua nova comunidade está pronta para uso.',
        class: 'bg-green-500 text-white'
      })
      resetForm()
    })
    .catch(() => {
      toast({
        title: 'Erro ao criar comunidade',
        description: 'Verifique os dados e tente novamente',
        variant: 'destructive'
      })
    })
    .finally(() => isCreatingCommunity.value = false)
}

function getCourses() {
  axios.get(`/courses?perPage=99999`)
    .then((res) => {
      courses.value = res.data.data
    })
}

onMounted(() => {
  getCourses()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_unref(Form), {
        as: "",
        "keep-values": "",
        "validation-schema": _unref(toTypedSchema)(_unref(formSchema))
      }, {
        default: _withCtx(({ meta, values, validate, resetForm }) => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(meta, values as FormSchemaType, validate, resetForm)), ["prevent"]),
            class: "space-y-8"
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "space-y-2 text-center" }, [
              _createElementVNode("h1", { class: "text-[1.1rem] font-bold tracking-tighter text-[#000] dark:text-white" }, "Nova comunidade"),
              _createElementVNode("p", { class: "text-sm text-[#666] dark:text-[#888]" }, "Crie uma nova comunidade para conectar pessoas")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(FormField), { name: "name" }, {
                default: _withCtx(({ componentField }) => [
                  _createVNode(_unref(FormItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormLabel), { class: "text-sm font-medium text-[#000] dark:text-white" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("Nome da Comunidade")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(FormControl), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Input), _mergeProps({
                            type: "text",
                            placeholder: "Digite o nome da comunidade"
                          }, componentField), null, 16)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(FormMessage))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(FormField), { name: "courseId" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(Label), { for: "courseId" }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("Curso")
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Select), _normalizeProps(_guardReactiveProps(componentField)), {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectTrigger), {
                          id: "courseId",
                          "aria-label": "Selecionar curso"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectValue), { placeholder: "Selecionar" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SelectContent), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (course) => {
                              return (_openBlock(), _createBlock(_unref(SelectItem), {
                                value: String(course.id)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(course.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 256))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(FormField), { name: "allowReactions" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(FormItem), { class: "flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Checkbox), _normalizeProps(_guardReactiveProps(field)), null, 16)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("Permitir Reações")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(FormDescription), null, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode(" Permite que os usuários reajam às postagens nesta comunidade. ")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "allowPosts" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(FormItem), { class: "flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Checkbox), _normalizeProps(_guardReactiveProps(field)), null, 16)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("Permitir Comentários")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(FormDescription), null, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Permite que os usuários comentem nas postagens desta comunidade. ")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "allowChat" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(FormItem), { class: "flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Checkbox), _normalizeProps(_guardReactiveProps(field)), null, 16)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("Permitir Chat")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(FormDescription), null, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" Permite que os usuários visualizem e comentem no chat ")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(Button), {
                disabled: isCreatingCommunity.value,
                type: "submit",
                class: "w-full text-white dark:text-[#000] font-medium py-2 px-4 rounded-md transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#000] dark:focus:ring-white focus:ring-opacity-50"
              }, {
                default: _withCtx(() => [
                  (isCreatingCommunity.value)
                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 0,
                        class: "w-4 h-4 mr-2 animate-spin"
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(isCreatingCommunity.value ? 'Criando...' : 'Adicionar Comunidade'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 40, _hoisted_2)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _createVNode(Toaster)
  ], 64))
}
}

})